/**
 * DashboardPage
 *
 * Main dashboard with overview statistics and metrics
 * (Placeholder - to be implemented)
 */

import { LayoutDashboard } from 'lucide-react';

export function DashboardPage() {
  return (
    <div className="h-full w-full flex items-center justify-center bg-slate-950">
      <div className="bg-slate-900/95 rounded-lg p-12 text-center border border-slate-700">
        <LayoutDashboard className="w-16 h-16 mx-auto mb-4 text-slate-500" />
        <h2 className="text-2xl font-bold text-white mb-2">Dashboard</h2>
        <p className="text-slate-400">
          Overview of missions, fleet status, and performance metrics.
        </p>
        <p className="text-slate-500 text-sm mt-4">Coming soon...</p>
      </div>
    </div>
  );
}
